/* eslint-disable class-methods-use-this */
import Cookies from 'js-cookie';

class CookieBasketService {
  basketIdCookiesName = 'basket_id';

  setDomain() {
    const isUWeb = window.location.host.indexOf('beelinetst') !== -1;
    const isWebTest = window.location.host.indexOf('webtest') !== -1;
    const isTestLoad = window.location.host.indexOf('beelinetstload') !== -1;

    if (isTestLoad) {
      return 'beelinetstload.ru';
    }

    if (isUWeb) {
      return 'beelinetst.ru';
    } else if (isWebTest) {
      return 'vimpelcom.ru';
    }

    return 'beeline.ru';
  }

  getBasketIdCookie() {
    return Cookies.get(this.basketIdCookiesName);
  }

  setBasketIdCookie(value) {
    const domain = this.setDomain();

    const nowMillis = new Date().getTime();
    const lifeTimeMillis = 24 * 60 * 60 * 1000; // 24 hours
    const expires = new Date(nowMillis + lifeTimeMillis);

    const options = {
      expires,
      domain,
    };

    Cookies.set(this.basketIdCookiesName, value, options);
  }

  setBasketItemsCookie(value) {
    const domain = this.setDomain();

    const nowMillis = new Date().getTime();
    const lifeTimeMillis = 24 * 60 * 60 * 1000; // 24 hours
    const expires = new Date(nowMillis + lifeTimeMillis);

    const options = {
      expires,
      domain,
    };

    Cookies.set('basketItemsCookie', value, options);
  }

  updateBasketIdCookie() {
    const basketIdCookie = this.getBasketIdCookie();
    if (basketIdCookie) {
      // если уже есть Cookie, то перезаписываем с новым expires
      this.setBasketIdCookie(basketIdCookie);
    }
  }
}

export const cookieBasketService = new CookieBasketService();
